import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * A wrapper component for routes that require authentication
 * If the user is not authenticated, they will be redirected to the login page
 */
function ProtectedRoute({ children }) {
  const { currentUser, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  console.log("🟠 VERIFICATION: ProtectedRoute - Checking authentication:", { 
    location: window.location.pathname,
    fullLocation: location,
    loading,
    isAuthenticated,
    hasCurrentUser: !!currentUser,
    currentUserData: currentUser ? {
      id: currentUser.id,
      username: currentUser.username,
      hasRoles: Array.isArray(currentUser.roles),
      roles: currentUser.roles
    } : null
  });

  // Show loading indicator while checking auth status
  if (loading) {
    console.log("🟠 VERIFICATION: ProtectedRoute - Still loading, showing spinner");
    return (
      <div className="text-center p-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3">Checking authentication status...</p>
      </div>
    );
  }

  // Redirect to login if user is not authenticated
  if (!isAuthenticated) {
    console.log("🟠 VERIFICATION: ProtectedRoute - Not authenticated, redirecting to /auth from", window.location.pathname);
    
    // Avoid redirect loops by not redirecting if already on the auth page
    if (location.pathname === '/auth') {
      console.log("🟠 VERIFICATION: ProtectedRoute - Already on /auth, not redirecting");
      return children;
    }
    
    return <Navigate to="/auth" replace state={{ from: window.location.pathname }} />;
  }

  // User is authenticated, render the protected content
  console.log("🟠 VERIFICATION: ProtectedRoute - Authentication confirmed, rendering children");
  return children;
}

export default ProtectedRoute; 